import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   FeaturedQuote,
} from '../extensions';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { TextStyleDropdown } from '../components/TextStyleDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   CodeBlockButton,
   BlockquoteButton,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
   UndoButton,
   RedoButton,
   InsertImageButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const AnswersExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   CustomHeading,
   History,
   BulletList,
   OrderedList,
   ListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   FeaturedQuote,
];

export const AnswersMenuBar = () => (
   <TiptapMenubar>
      <BoldButton />
      <ItalicButton />
      <CodeButton />
      <LinkButton />
      <MenuSeparator />
      <TextStyleDropdown />
      <MenuSeparator />
      <CodeBlockButton />
      <BlockquoteButton />
      <BulletListButton />
      <OrderedListButton />
      <UnindentButton />
      <IndentButton />
      <MenuSeparator />
      <InsertImageButton />
      <MenuSeparator />
      <UndoButton />
      <RedoButton />
   </TiptapMenubar>
);
